import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { ModalDirective } from 'ngx-bootstrap/modal';

/*
 * Template Implementation Example
 *
 * <!-- Button to activate modal -->
 * <button type="button" class="btn btn-primary" (click)="confirmBeforeAuthorizingPayment()">Save</button>
 *
 * <!-- Modal component -->
 * <pioneer-confirmation-modal (closed)="confirmHandler($event)"></pioneer-confirmation-modal>
 *
 *
 * Component Implementation Example
 *
 * import { Component, OnInit, ViewChild } from '@angular/core';
 * import { ModalDirective } from 'ngx-bootstrap/modal';
 * import { ConfirmationModalComponent } from '../../shared/confirmation-modal/confirmation-modal.component';
 * @Component({
 *  selector: 'pioneer-example',
 *  templateUrl: './example.component.html'
 * })
 * export class ExampleComponent {
 *   @ViewChild(ConfirmationModalComponent)
 *   public confirmationModal: ConfirmationModalComponent;
 *
 *   public confirmBeforeAuthorizingPayment(): void {
 *     this.confirmationModal.open();
 *   }
 *
 *   public confirmHandler(value) {
 *     if (value) {
 *       this.save();
 *     }
 *   }
 *
 *   public save() {
 *     ...
 *   }
 * }
 */

@Component({
  selector: 'pioneer-confirmation-modal',
  templateUrl: './confirmation-modal.component.html'
})
export class ConfirmationModalComponent implements OnInit {

  @Input()
  public cancel = 'COMMON.BUTTON.DISCARD';

  @Input()
  public confirm = 'COMMON.BUTTON.CONTINUE';

  @Input()
  public title = 'MESSAGES.CONFIRMATION.EXIT_TITLE';

  @Input()
  public content = 'MESSAGES.CONFIRMATION.EXIT_MESSAGE';

  @Input()
  public config = {
    backdrop: 'static'
  };

  @Output()
  public closed = new EventEmitter();

  @ViewChild(ModalDirective)
  public confirmationModal: ModalDirective;

  constructor() {
  }

  ngOnInit() {
  }

  public open(): void {
    this.confirmationModal.show();
  }

  public close(value: boolean): void {
    this.closed.emit(value);
    this.confirmationModal.hide();
  }

}



// WEBPACK FOOTER //
// /var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/src/app/shared/confirmation-modal/confirmation-modal.component.ts